import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { PlansService } from 'src/app/core/services/plans.service';
import { Location } from '@angular/common';
import { PrivateLibraryPackageService } from 'src/app/core/services/private-library-package.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-upload-space-modal',
  templateUrl: './upload-space-modal.component.html',
  styleUrls: ['./upload-space-modal.component.scss']
})
export class UploadSpaceModalComponent implements OnInit, OnDestroy {

  @Input() spaceError;
  @Input() contentAccessError;
  @Input() contentType;
  @Input() isRedirectRequired = true;
  contentAccess: boolean = false;
  activePlan;

  constructor(private activeModal: NgbActiveModal, private _plansService: PlansService,
    private contentServie: PrivateLibraryPackageService, private _spinner: NgxSpinnerService,


    private router: Router, private location: Location
  ) { }
  ngOnInit() {
    if (this.spaceError) {
      this.contentAccess = true;
    }
    this.getActivePlan();
  }

  closeDialog() {
    this.contentAccess = false;
    this.activeModal.close('success');
      // console.log("close dialog");
      
  }


  ContentIdRedirect: any
  ContentIdResponse: any
  ContentIdResponseerrors: any
  ContentIdCheck: boolean = false
  ContentIDArrynumber:any
  PlayListContentIdRedirect: any
  PlayListContentIdResponse: any
  PlayListContentIdResponseerrors: any

  PackageContentIdRedirect: any
  PackageContentIdResponse: any
  PackageContentIdResponseerrors: any

  YoucannotviewplaylistIdRedirect: any
  YoucannotviewplaylistIdResponse: any
  YoucannotviewplaylistIdResponseerrors: any

  ok() {
    // if (this.isRedirectRequired) {
    //   this.router.navigate(['/']);
    // }

    setTimeout(() => {
      this.contentAccess = true;
      // this.activeModal.close();

    }, 400);
    // console.log("buton ok");
    this.activeModal.close();


    var ContentIDArry = this._plansService.ContentIdArray[0]
    this.ContentIDArrynumber = this._plansService.ContentIdArraynumer
    var Contentlist = "Content owner account is private, connect with them to view the material."

    if (Contentlist == this.contentAccessError) {
      this.router.navigate(['other-profile/' + this.ContentIDArrynumber]);

    }

  }

  getActivePlan() {
    this._plansService.getActivePlan().subscribe((response: any) => {
      if (response.success) {
        this.activePlan = response.data.subscription[0];
      }
    })
  }

  ngOnDestroy() {

  

      if (this.contentAccessError && !this.contentAccessError.includes('within range') && !this.contentAccessError.includes('access to this user') && this.isRedirectRequired) {
   
        
           this.router.navigate(['/']);
     
       
      } else if (this.contentAccessError && this.contentAccessError.includes('access to this user')) {
        this.location.back();
      }
   
 
}
}
